import type { DtoSubmitApplicationToLenderResult } from "@porchpass/api-client";

export function mapLenderSubmitResults(
  results: DtoSubmitApplicationToLenderResult[],
): Record<string, DtoSubmitApplicationToLenderResult> {
  const resultMap: Record<string, DtoSubmitApplicationToLenderResult> = {};

  for (const result of results) {
    if (!result.lender_id) continue;
    resultMap[result.lender_id] = result;
  }

  return resultMap;
}
